module.exports = __webpack_public_path__ + "static/media/ft-widgets.25ef907d.svg";